import { useState } from 'react'
import {
  Box,
  Button,
  useTheme,
  Typography,
  Chip,
  IconButton,
  Collapse,
  Tooltip,
} from '@mui/material'
import ChatIcon from '@mui/icons-material/Chat'
import { useTranslation } from 'react-i18next'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

import { TgChatsModal } from './tg-chats-modal.component'
import { ESettingsTgChatIdsFields } from 'src/types'
import { parseChatTag } from './tg-chat.utils'

interface IProps {
  field: ESettingsTgChatIdsFields
  handleUpdate: (list: string[], field: ESettingsTgChatIdsFields) => void
  label: string
  isMobile?: boolean
  tags: string[]
}

export const SettingsTgChatsList = ({
  field,
  handleUpdate,
  label,
  tags,
  isMobile = false,
}: IProps) => {
  const [t] = useTranslation()

  const [isEditing, setIsEditing] = useState(false)
  const [openCollapse, setOpenCollapse] = useState(true)

  const theme = useTheme()

  const handleClose = () => {
    setIsEditing(false)
  }

  return (
    <>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          alignItems: 'flex-start',
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            justifyContent: 'space-between',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: isMobile ? '20px' : '10px' }}>
            {!isMobile && (
              <IconButton onClick={() => setOpenCollapse(!openCollapse)}>
                <ExpandMoreIcon
                  sx={{
                    transform: openCollapse ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s',
                  }}
                />
              </IconButton>
            )}
            {isMobile && (
              <ChatIcon
                sx={{
                  width: isMobile ? '40px' : '24px',
                  height: isMobile ? '40px' : '24px',
                  color: isMobile ? theme.palette.custom.primary : theme.palette.custom.black,
                }}
              />
            )}

            <Typography
              sx={{
                fontSize: isMobile ? '18px' : 'inherit',
                fontWeight: isMobile ? 700 : 'inherit',
              }}
            >
              {label}
            </Typography>
          </Box>
          <Button variant="outlined" size="small" onClick={() => setIsEditing(true)}>
            {t('edit-button-text.v')}
          </Button>
        </Box>
        {!isMobile && (
          <Collapse in={openCollapse} sx={{ width: '100%' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'start',
                width: '100%',
                alignItems: 'center',
                gap: '12px',
              }}
            >
              {tags.map((tag, index) => {
                const { fullId, name } = parseChatTag(tag)

                return (
                  <Tooltip title={fullId}>
                    <Chip key={index} label={name} sx={{ fontWeight: 500 }} />
                  </Tooltip>
                )
              })}
            </Box>
          </Collapse>
        )}
      </Box>
      <TgChatsModal
        handleClose={handleClose}
        open={isEditing}
        field={field}
        handleUpdate={handleUpdate}
        initialTags={tags}
      />
    </>
  )
}
